import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import LoadingSpinner from './components/LoadingSpinner.jsx';
import { ToastProvider } from './contexts/ToastContext.jsx';
import CookieConsent from './components/CookieConsent.jsx';
import './App.css';

// Lazy load all pages for better performance
const HomePage = lazy(() => import('./pages/HomePage.jsx'));
const HairServicePage = lazy(() => import('./pages/HairServicePage.jsx'));
const NailServicePage = lazy(() => import('./pages/NailServicePage.jsx'));
const SkinBodyServicePage = lazy(() => import('./pages/SkinBodyServicePage.jsx'));
const MakeupPage = lazy(() => import('./pages/makeuppage.jsx'));
const ContactPage = lazy(() => import('./pages/ContactPage.jsx'));
const BlogPage = lazy(() => import('./pages/BlogPage.jsx'));
const BlogDetailPage = lazy(() => import('./pages/BlogDetailPage.jsx'));
const ExploreServices = lazy(() => import('./pages/ExploreServices.jsx'));
const AdminLogin = lazy(() => import('./pages/AdminLogin.jsx'));
const AdminPanel = lazy(() => import('./pages/AdminPanel.jsx'));
const BlogFormPage = lazy(() => import('./pages/BlogFormPage.jsx'));
const ErrorPage = lazy(() => import('./pages/ErrorPage.jsx'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy.jsx'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions.jsx'));
const AcademyPage = lazy(() => import('./pages/AcademyPage.jsx'));

function App() {
  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <CookieConsent />
          
          <Suspense fallback={<LoadingSpinner message="Loading page..." />}>
          {/* Hidden Admin Routes (no navbar) */}
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/panel" element={<AdminPanel />} />
            <Route path="/admin/blog/new" element={<BlogFormPage />} />
            <Route path="/admin/blog/edit/:id" element={<BlogFormPage />} />
            <Route path="/academy" element={<AcademyPage />} />
            
            {/* Public Routes (with navbar) */}
            <Route path="*" element={
              <>
                <Navbar />
                <Suspense fallback={<LoadingSpinner message="Loading page..." />}>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/hair-service-in-madhapur" element={<HairServicePage />} />
                    <Route path="/nail-service-in-madhapur" element={<NailServicePage />} />
                    <Route path="/skin-body-service-in-madhapur" element={<SkinBodyServicePage />} />
                    <Route path="/makeup-service-in-madhapur" element={<MakeupPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/blog/:id" element={<BlogDetailPage />} />
                    <Route path="/explore-services" element={<ExploreServices />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                    <Route path="*" element={<ErrorPage />} />
                  </Routes>
                </Suspense>
              </>
            } />
          </Routes>
        </Suspense>
      </div>
    </Router>
    </ToastProvider>
  );
}

export default App;
